const clientSlider = () => {
  if (exists('.client_slider')) {
    $('.client_slider').slick({
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      cssEase: 'linear',
      dots: false,
      draggable: false,
      slidesToScroll: 1,
      slidesToShow: 10,
      speed: 5000,
      swipe: false,
      touchMove: false,
      variableWidth: true,
    });
  }
};

clientSlider();
